import {
  faCirclePlus,
  faTrashCan,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";
import { formatDate } from "../../../../../../../../utils/common";
import Instrument_Maintance from "../../../../../../../../common/common_modal/instrument_maintance/Instrument_Maintance";
import { FixIDS } from "../../../../../../../../utils/fixIDS";
import Delete_offcanvas from "../../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  instrumentDelete,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";
import Instrument_Check_Edit_Offcanvas from "../Instrument_Check_Edit_Offcanvas/Instrument_Check_Edit_Offcanvas";

function Instrument_Check_table({
  handleClose,
  data,
  currentPage,
  setCurrentPage,
  fetchCustomers,
 
}) {
  const [success, setSuccess] = useState(false);

  //add maintenance status table edit
  const [editData, setEditData] = useState("");
  const [edit, setEdit] = useState("");

  // action edit
  const [showEdit, setShowEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const totalPages = Math.ceil(data.total_pages);

  const dispatch = useDispatch();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(instrumentDelete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.instrument_check.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.instrument_check.Delete,
  );

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Sr. No</th>
                  <th rowSpan="2">Date</th>
                  <th rowSpan="2">Instrument ID</th>
                  <th rowSpan="2">Instrument Name</th>
                  <th rowSpan="2">Maintenance Check Points</th>
                  <th colSpan="2" className="text-center">
                    Break Down
                  </th>

                  <th rowSpan="2">Next Due On</th>
                  {/* <th rowSpan="2">Internal / External</th> */}
                  <th rowSpan="2">Check By</th>
                  <th rowSpan="2"> Remarks</th>
                  <th rowSpan="2">Action</th>
                </tr>

                <tr>
                  <th>From</th>
                  <th>To</th>
                </tr>
              </thead>

              <tbody>
                {data?.data?.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {(currentPage - 1) *
                        (data?.per_page || data?.data?.length || 0) +
                        index +
                        1}
                    </td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td>{row.Instrument_Management?.unique_id}</td>
                    <td>{row.Instrument_Management?.instrument_name}</td>

                    <td>
                      <ul className="check_point_list">
                        {row.Instrument_Check_Points.map((c, i) => (
                          <li key={i}>
                            {c?.Maintenance_Check_Points_Seeder?.name}
                          </li>
                        ))}
                      </ul>

                      <div className="add_another_holder">
                        <div className="note_text_holder">
                          <p
                            className="red_text"
                            onClick={() => {
                              setEditData(row);
                              setEdit(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCirclePlus} /> Add
                            Maintenance Status
                          </p>
                        </div>
                      </div>
                    </td>

                    <td>{row.from_date || "-"}</td>
                    <td>{row.to_date || "-"}</td>
                    <td>{row.next_date || "-"}</td>
                    {/* <td>{row.type}</td> */}
                    <td>{row.Instrument_Management?.User?.name}</td>
                    <td>{row?.remark}</td>

                    {/* Action */}
                    <td>
                      <div className="action_icons">
                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => {
                              setShowEdit(true);
                              setEditId(row.id);
                            }}
                          />
                        )}
                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedDeleteId(row.id); // store ID
                              setDelete(true); // open offcanvas
                            }}
                          />
                        )}
                      </div>
                    </td>
                    {/* <td>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Type Here Remark..."
                      />
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      {/* <div className="permission_btn_holder">
        {success ? (
          <Success_Toster successText="Save Audit Successfully!" />
        ) : (
          <>
            <Button type="button" className="permission_btn No_btn">
              Reset
            </Button>

            <Button
              type="button"
              className="permission_btn Yes_btn"
              onClick={() => setSuccess(true)}
            >
              Save
            </Button>
          </>
        )}
      </div> */}

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(data.current_page - 1) * data.per_page + 1} To{" "}
            {Math.min(data.current_page * data.per_page, data.total)} Of{" "}
            {data.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
        <Instrument_Maintance
          show={edit}
          onHide={() => setEdit(false)}
          data={editData}
        />
      </div>

      {/* Edit */}
      {haveEditPermission && (
        <Instrument_Check_Edit_Offcanvas
          show={showEdit}
          handleClose={() => setShowEdit(false)}
          id={showEditId}
          setSuccess={setSuccess}
          fetchCustomers={fetchCustomers}
        />
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Instrument Check"
          massageText={"Instrument Check"}
          fetchCustomers={fetchCustomers}
        />
      )}
    </>
  );
}

export default Instrument_Check_table;
